import { render, staticRenderFns } from "./DetailsInformationFund.vue?vue&type=template&id=d766cec0&"
import script from "./DetailsInformationFund.vue?vue&type=script&lang=js&"
export * from "./DetailsInformationFund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports